import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=79c6e9e8&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=js&"
export * from "./EditIcon.vue?vue&type=script&lang=js&"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=79c6e9e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c6e9e8",
  null
  
)

export default component.exports